var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface9509359"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(0.392157%,61.960787%,97.647059%)","fillOpacity":"1"},"d":"M 24 4 C 12.953125 4 4 12.953125 4 24 C 4 35.046875 12.953125 44 24 44 C 35.046875 44 44 35.046875 44 24 C 44 12.953125 35.046875 4 24 4 Z M 24 34 C 22.894531 34 22 33.105469 22 32 L 22 24 C 22 22.894531 22.894531 22 24 22 C 25.105469 22 26 22.894531 26 24 L 26 32 C 26 33.105469 25.105469 34 24 34 Z M 25 18 L 23 18 C 22.449219 18 22 17.550781 22 17 L 22 15 C 22 14.449219 22.449219 14 23 14 L 25 14 C 25.550781 14 26 14.449219 26 15 L 26 17 C 26 17.550781 25.550781 18 25 18 Z M 25 18 "})));
}

Info.defaultProps = {"viewBox":"0 0 48 48","width":"48px","height":"48px"};

module.exports = Info;

Info.default = Info;
